import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetUsersByReg } from "../actions/UserActions"
import { actionGetRolesRedimidores, actionSaveRol, actionDeleteRol } from "../actions/RolActions"

import { LOGIN_ROUTE, ROLES_ADD_ROUTE, ROLES_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  Checkbox,
  Chip,
  Collapse,
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography, 
  Fab,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListSubheader,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableSortLabel,
  TableFooter,
  TablePagination,
  Tooltip,
  TextField,
  SvgIcon
} from "@material-ui/core"
import { Autocomplete } from"@material-ui/lab"

import { withTheme } from "@material-ui/core/styles"
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Util, { SUCCESS,ERROR } from '../common/Util'
import moment from "moment"

const MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
class Roles extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={selectedRolIndex:0, loadingUsers:false, rolesRedimidoresListFilter:[], usersFiltred:[], rolForDelete:null, searchText:""}
    this.onAddRol=this.onAddRol.bind(this)
    this.onConfirmDeleteRol=this.onConfirmDeleteRol.bind(this)
    this.onInputChangeUser=this.onInputChangeUser.bind(this)
    this.onInputSearchRolChange=this.onInputSearchRolChange.bind(this)
    this.onSearchRol=this.onSearchRol.bind(this)
    this.onAddUser=this.onAddUser.bind(this)
    this.renderRoles.bind(this)
  }

  componentWillMount(){
    console.log("LOGIN", this.props.login)
    if(this.props.login){
     this.props.actionGetRolesRedimidores(()=>{
      this.setState({rolesRedimidoresListFilter:this.props.rolesRedimidoresList})
     },(e)=>{
       Util.showNoty(ERROR, "No pudimos consultar los roles")
     })
    }else{
      this.props.history.push(LOGIN_ROUTE)
    }
  }

  onAddRol(){
    this.props.history.push(ROLES_ADD_ROUTE)
  }

  onEditRol(rol){
    this.props.history.push(ROLES_EDIT_ROUTE, {rol:rol})
  }

  onDeleteRol(rol){
    this.setState({rolForDelete:rol})
  }

  onConfirmDeleteRol(){
    const rol = this.state.rolForDelete
    this.props.actionDeleteRol(rol,()=>{
        Util.showNoty(SUCCESS,`Se eliminó el rol ${rol.rolName} correctamente`)
        console.log("actionDeleteRol callback", this.state.selectedRolIndex)
        this.props.actionGetRolesRedimidores(this.onSearchRol,(e)=>{
          console.log("actionGetRolesRedimidores callback", this.state.selectedRolIndex)
          Util.showNoty(ERROR, "No pudimos consultar los roles")
        })
      },
      (e)=>{
        Util.showNoty(ERROR,`No pudimos eliminar el rol ${rol.rolName}`)
        
      }
    )
    this.setState({rolForDelete:null})
  }

  onInputSearchRolChange(event){
    this.setState({searchText:event.target.value})
  }

  onSearchRol(){
    const {rolesRedimidoresList} = this.props
    console.log("onSearchRol", rolesRedimidoresList)
    const filter = new RegExp(this.state.searchText,"gi")
    const rolesRedimidoresListFilter = rolesRedimidoresList.filter((r)=>{return r.rolName.match(filter)})
    this.setState({rolesRedimidoresListFilter:rolesRedimidoresListFilter,selectedRolIndex:0})
  }

  onSelectRol(index, evt){
    this.setState({selectedRolIndex:index})
  }

  onInputChangeUser(evt){
    if(!this.state.loadingUsers&&evt&&evt.target&&evt.target.value){
      const { userList } = this.props
      const filter = new RegExp(evt.target.value,"gi")
      if(evt.target.value.length==3){
        //BUSCAR EN BACKEND
        this.setState({loadingUsers:true})
        this.props.actionGetUsersByReg(evt.target.value, (response)=>{
          let usersFiltred = response.filter((u)=>{
            return u.proName&&u.proName.match(filter)||
                  u.proLastName&&u.proLastName.match(filter)||
                  u.proEmail&&u.proEmail.match(filter)
          })
          this.setState({usersFiltred:usersFiltred, loadingUsers:false})
        },(e)=>{
          this.setState({loadingUsers:false})
          console.log("ACTION GET USERS ERROR", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No pudimos listar los usuarios")
        })
      }else{
        if(evt.target.value.length>3){
          //FILTRAR EN FRONT
          let usersFiltred = userList&&userList.filter((u)=>{
            return u.proName&&u.proName.match(filter)||
                  u.proLastName&&u.proLastName.match(filter)||
                  u.proEmail&&u.proEmail.match(filter)        
            })
          this.setState({usersFiltred:usersFiltred})
        }
      }
    }
  }

  onAddUser(evt, user){
    if(user){
      const { rolesRedimidoresList } = this.props
      const rol = {...rolesRedimidoresList[this.state.selectedRolIndex]}
      const notExist = rol.rolUsers.indexOf((u)=>u.id==user.id)==-1
      if(notExist){
        rol.rolUsers.push({id:user.id, proName:user.proName, proLastName:user.proLastName, proEmail:user.proEmail})
        console.log("USERS", user)
        this.props.actionSaveRol(rol,()=>{
          rolesRedimidoresList[this.state.selectedRolIndex] = rol
          Util.showNoty(SUCCESS,`Se asignó el rol ${rol.rolName} a ${user.proName} ${user.proLastName} correctamente`)
        },
        (e)=>{
          Util.showNoty(ERROR,`No pudimos asignar el rol ${rol.rolName} a ${user.proName} ${user.proLastName}`)
        })
      }else{
        Util.showNoty(ERROR,`El usuario ${user.proName} ${user.proLastName} ya tiene el rol ${rol.rolName}`)
      }
      evt.target.value=null
      evt.target.innerHtml = ""
    }
    console.log("TARGET", evt.target)

    // this.setState({usersSelected:users})
  }

  onDeleteUser(user){
    if(user){
      const { rolesRedimidoresList } = this.props
      const rol = {...rolesRedimidoresList[this.state.selectedRolIndex]}
      const rolUsers = rol.rolUsers.filter((u)=>u.id!=user.id)
      rol.rolUsers = rolUsers
      this.props.actionSaveRol(rol,()=>{
        rolesRedimidoresList[this.state.selectedRolIndex] = rol
        Util.showNoty(SUCCESS,`Se quitó el rol ${rol.rolName} a ${user.proName} ${user.proLastName} correctamente`)
      },
      (e)=>{
        Util.showNoty(ERROR,`No pudimos quitar el rol ${rol.rolName} a ${user.proName} ${user.proLastName}`)
      })
    }
  }

  renderRoles(){
    const {rolesRedimidoresListFilter} = this.state
    return rolesRedimidoresListFilter.map((r,i)=>{
      const isSelected = this.state.selectedRolIndex == i
      console.log("RENDER ROLES", this.state.selectedRolIndex, i)
      return [<ListItem button
                        color="primary"
                        selected={isSelected}
                        onClick={this.onSelectRol.bind(this, i)}>
              {/* {isSelected ? <ExpandLess /> : <ExpandMore />} */}
              <ListItemText primary={r.rolName} secondary={r.rolDesc}/>
              <ListItemSecondaryAction>
                <Tooltip title="Editar rol">
                  <IconButton onClick={this.onEditRol.bind(this,r)}>
                    <EditIcon/>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar rol">
                  <IconButton>
                    <DeleteIcon onClick={this.onDeleteRol.bind(this,r)}/>
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
              </ListItem>,
              <Collapse in={isSelected} timeout="auto" unmountOnExit style={{backgroundColor:"black", color:"white", paddingLeft:12}}>
                <List disablePadding dense
                      subheader={
                        <ListSubheader component="div" style={{color:"rgba(255,255,255,0.7)"}}>
                          Permisos
                        </ListSubheader>
                  }>
                  {this.renderRolDetails(i)}
                </List>
              </Collapse>]
    })
  }

  renderRolDetails(rolIndex){
    const { rolesRedimidoresListFilter } = this.state
    if(rolesRedimidoresListFilter&&rolesRedimidoresListFilter.length){
      console.log("renderRolDetails", rolIndex, rolesRedimidoresListFilter[rolIndex], rolesRedimidoresListFilter)

      const permissions = rolesRedimidoresListFilter[rolIndex].rolPermissions
      return permissions.map((p)=>{
        return (
          <ListItem color="primary">
            <ListItemText primary={p.label}/>
          </ListItem>
        ) 
      })
    }
  }

  renderUsersXRol(rolIndex){
    const { rolesRedimidoresList } = this.props
    if(rolesRedimidoresList&&rolesRedimidoresList.length){
      const users = rolesRedimidoresList[rolIndex].rolUsers
      return users.map((u)=>{
          return (
            <ListItem color="primary">
              <ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proEmail}/>
              <ListItemSecondaryAction>
                <Tooltip title="Eliminar rol al usuario">
                  <IconButton onClick={this.onDeleteUser.bind(this,u)}>
                    <DeleteIcon/>
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          )
        })
    } 
  }

  renderPlacesXRol(rolIndex){
    const { rolesRedimidoresList } = this.props
    if(rolesRedimidoresList&&rolesRedimidoresList.length){
      const places = rolesRedimidoresList[rolIndex].rolPlaces
      return places.map((p)=>{
          return (
            <ListItem color="primary">
              <ListItemText primary={p.plcName} secondary={p.plcAddress}/>
            </ListItem>
          )
        })
    } 
  }
  
  render(){
    const { theme, userList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Roles</Typography>
          <Typography variant="subtitle1">Crea roles</Typography>
        </Box>
        <Container style={{...theme.table.container, maxWidth:"100%"}}>        
          <Paper>
            <Box style={{display:"flex", alignItems:"center"}}>
              <Typography style={theme.paper.title} variant="h2">Listado de roles</Typography>
            </Box>
            <Grid container spacing={4}>
              <Grid item xs={5} spacing={4}>
                <Toolbar style={{justifyContent:"space-between"}}>
                  <Box style={{display:"flex",width:"80%"}}>
                  <TextField label="Buscar Rol" fullWidth onChange={this.onInputSearchRolChange} value={this.state.searchText}/>
                    <Tooltip title="Buscar rol">
                      <IconButton onClick={this.onSearchRol}>
                        <SearchIcon/>
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Tooltip title="Agregar rol">
                    <Fab size="smal" color="primary" onClick={this.onAddRol}>
                      <AddIcon/>
                    </Fab>
                  </Tooltip>
                </Toolbar>
                <List subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                          Roles
                        </ListSubheader>
                  }>
                    {this.renderRoles()}
                </List>
              </Grid>
              <Grid item xs={3}>
                <Toolbar style={{padding:0}}>
                  {/* <Fab size="smal" color="primary">
                    <AddIcon/>
                  </Fab> */}
                   <Autocomplete  
                      options={this.state.usersFiltred}
                      getOptionLabel={option=>`${option.proName} ${option.proLastName}`}
                      renderInput={params=>{
                        return <TextField {...params} fullWidth label="Agregar usuarios" helperText="Escriba al menos 3 letras para buscar"/>
                      }}
                      renderOption={(u)=><ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proEmail}/>}
                      onChange={this.onAddUser}
                      onInputChange={this.onInputChangeUser}
                      loading={this.state.loadingUsers}
                      loadingText="Cargando usuarios ..."
                      noOptionsText="Sin usuarios"
                      blurOnSelect
                      selectOnFocus
                      clearOnBlur
                      clearOnEscape
                    />
                    {/* <IconButton>
                      <AddIcon/>
                    </IconButton> */}
                </Toolbar>
                <List subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                          Usuarios con el rol seleccionado
                        </ListSubheader>
                  }>
                    {this.renderUsersXRol(this.state.selectedRolIndex)}
                </List>
              </Grid>
              <Grid item xs={4}>
                <List style={{marginTop:64}}
                      subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                          Ubicaciones dónde aplican los permisos
                        </ListSubheader>
                  }>
                    {this.renderPlacesXRol(this.state.selectedRolIndex)}
                </List>
              </Grid>
            </Grid>
          </Paper>
          <Dialog open={this.state.rolForDelete}>
            <DialogTitle>Eliminar Rol</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el rol {this.state.rolForDelete&&this.state.rolForDelete.rolName} ?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({rolForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar rol">  
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteRol}>Eliminar</Button>
              </Tooltip>  
            </DialogActions>
          </Dialog>
      </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    authEmail: store.auth.email,
    rolesRedimidoresList: store.rol.rolesRedimidoresList,
    userList: store.usr.userList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetRolesRedimidores,
      actionGetUsersByReg,
      actionSaveRol,
      actionDeleteRol
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Roles)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Roles.js